import { MODAL_ERROR_SHOW, MODAL_ERROR_HIDE } from '@store/modalError/actions';

export const initialState = {
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case MODAL_ERROR_SHOW: {
      return {
        ...state,
        error: action.error,
        preventPageReload: action.preventPageReload,
        keepPage: action.keepPage,
      };
    }
    case MODAL_ERROR_HIDE: {
      return {
        ...state,
        error: null,
      };
    }
    default:
      return state;
  }
};
